export { default as NavFeaturedProduct } from './NavFeaturedProduct';
